<nav class="navbar navbar-default">
    <div class="container-fluid">
        <div class="navbar-header">
            <button type="button" class="navbar-toggle collapsed" data-toggle="collapse"
                data-target="#bs-example-navbar-collapse-1" (click)="toggleNavbar()">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
            </button>
            <a class="navbar-brand logo float-xs-right" uiSref="home" (click)="collapseNavbar()">
                <span class="logo-img"></span><span class="navbar-version">{{version}}</span>
            </a>
        </div>

        <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1" [ngbCollapse]="isNavbarCollapsed"
            [ngSwitch]="isAuthenticated()">
            <ul class="nav navbar-nav">

                <!-- Sessions -->
                <li ngbDropdown class="nav-item dropdown pointer">
                    <a class="nav-link dropdown-toggle" ngbDropdownToggle href="javascript:void(0);" id="session-menu">
                        <i class="fa fa-bookmark-o" aria-hidden="true"></i>
                        <span class="hidden-sm">
                            {{ 'global.menu.session.main' | translate}}
                        </span>
                    </a>
                    <ul class="dropdown-menu dropdown-menu-left" ngbDropdownMenu>
                        <li *jhiHasAnyAuthority="['ROLE_ADMIN', 'ROLE_SALE', 'ROLE_SESSION_PLANNER']">
                            <a class="dropdown-item" uiSref="sessions-list" uiSrefActive="active"
                                (click)="collapseNavbar()">
                                <i class="fa fa-fw fa fa-list" aria-hidden="true"></i>
                                <span jhiTranslate="global.menu.session.list">List</span>
                            </a>
                        </li>
                        <li *jhiHasAnyAuthority="['ROLE_TRAINER']">
                            <a class="dropdown-item" uiSref="sessions-list-mine" uiSrefActive="active"
                                (click)="collapseNavbar()">
                                <i class="fa fa-fw fa-list" aria-hidden="true"></i>
                                <span jhiTranslate="global.menu.session.mine">My sessions</span>
                            </a>
                        </li>
                        <li *jhiHasAnyAuthority="['ROLE_ADMIN', 'ROLE_SALE', 'ROLE_SESSION_PLANNER']">
                            <a class="dropdown-item" uiSref="sessions-list-deleted" uiSrefActive="active"
                                (click)="collapseNavbar()">
                                <i class="fa fa-fw fa fa-list" aria-hidden="true"></i>
                                <span jhiTranslate="global.menu.session.deleted">Deleted sessions</span>
                            </a>
                        </li>
                        <li *jhiHasAnyAuthority="['ROLE_ADMIN', 'ROLE_SALE', 'ROLE_SESSION_PLANNER']">
                            <a class="dropdown-item" uiSref="sessions-calendar" uiSrefActive="active"
                                (click)="collapseNavbar()">
                                <i class="fa fa-fw fa-calendar" aria-hidden="true"></i>
                                <span jhiTranslate="global.menu.session.calendar">Calendar</span>
                            </a>
                        </li>
                        <li *jhiHasAnyAuthority="'ROLE_ADMIN'">
                            <a class="dropdown-item" uiSref="session-staffings" uiSrefActive="active"
                                (click)="collapseNavbar()">
                                <i class="fa fa-fw fa fa-binoculars" aria-hidden="true"></i>
                                <span jhiTranslate="global.menu.session.virtual-list">Virtual List</span>
                            </a>
                        </li>
                        <li *jhiHasAnyAuthority="'ROLE_ADMIN'">
                            <a class="dropdown-item" uiSref="session-staffing-answers" uiSrefActive="active"
                               (click)="collapseNavbar()">
                                <i class="fa fa-fw fa fa-search" aria-hidden="true"></i>
                                <span jhiTranslate="global.menu.session.staffing-answers">Virtual List</span>
                            </a>
                        </li>
                    </ul>
                </li>

                <!-- Trainings -->
                <li *jhiHasAnyAuthority="['ROLE_ADMIN', 'ROLE_SALE', 'ROLE_SESSION_PLANNER', 'ROLE_TRAINER']"
                    class="nav-item" uiSrefActive="active">
                    <a class="nav-link" uiSref="trainings" (click)="collapseNavbar()">
                        <i class="fa fa-code" aria-hidden="true"></i>
                        <span class="hidden-sm" jhiTranslate="global.menu.trainings">Trainings</span>
                    </a>
                </li>

                <!-- Trainers -->
                <li *jhiHasAnyAuthority="['ROLE_ADMIN', 'ROLE_SALE', 'ROLE_TRAINER']" class="nav-item"
                    uiSrefActive="active">
                    <a class="nav-link" uiSref="trainers" (click)="collapseNavbar()">
                        <i class="fa fa-users" aria-hidden="true"></i>
                        <span class="hidden-sm" jhiTranslate="global.menu.trainers">Trainers</span>
                    </a>
                </li>

                <!-- Statistics -->
                <li *jhiHasAnyAuthority="['ROLE_ADMIN', 'ROLE_SALE']" class="nav-item dropdown pointer" ngbDropdown>
                    <a class="nav-link dropdown-toggle" ngbDropdownToggle href="javascript:void(0);" id="stats-menu">
                        <i class="fa fa-fw fa-bar-chart" aria-hidden="true"></i>
                        <span class="hidden-sm">Statistiques</span>
                    </a>
                    <ul class="dropdown-menu dropdown-menu-left" ngbDropdownMenu>
                        <li *ngSwitchCase="true" class="nav-item" uiSrefActive="active">
                            <a lass="nav-link" uiSref="floating-turnover" (click)="collapseNavbar()">
                                <i class="fa fa-fw fa-money" aria-hidden="true"></i>
                                <span>CA par mois</span>
                            </a>
                        </li>
                        <li *ngSwitchCase="true" class="nav-item" uiSrefActive="active">
                            <a lass="nav-link" uiSref="data-analysis" (click)="collapseNavbar()">
                                <i class="fa fa-fw fa-shopping-bag" aria-hidden="true"></i>
                                <span>Analyse de ventes</span>
                            </a>
                        </li>
                    </ul>
                </li>

                <!-- Annuaire -->
                <li ngbDropdown class="nav-item dropdown pointer"
                    *jhiHasAnyAuthority="['ROLE_ADMIN', 'ROLE_SALE', 'ROLE_SESSION_PLANNER']">
                    <a class="nav-link dropdown-toggle" ngbDropdownToggle href="javascript:void(0);" id="annuaire-menu">
                        <i class="fa fa-address-book-o" aria-hidden="true"></i>
                        <span class="hidden-sm">
                            {{ 'global.menu.directory.main' | translate}}
                        </span>
                    </a>
                    <ul class="dropdown-menu dropdown-menu-left" ngbDropdownMenu>
                        <li *ngSwitchCase="true">
                            <a *jhiHasAnyAuthority="'ROLE_ADMIN'" class="dropdown-item" uiSref="students"
                                uiSrefActive="active" (click)="collapseNavbar()">
                                <i class="fa fa-fw fa-graduation-cap" aria-hidden="true"></i>
                                <span jhiTranslate="global.menu.directory.students">students</span>
                            </a>
                        </li>
                        <li *jhiHasAnyAuthority="'ROLE_ADMIN'">
                            <a class="dropdown-item" uiSref="contacts" uiSrefActive="active" (click)="collapseNavbar()">
                                <i class="fa fa-fw fa-user" aria-hidden="true"></i>
                                <span jhiTranslate="global.menu.directory.contacts">contacts</span>
                            </a>
                        </li>
                        <li *jhiHasAnyAuthority="'ROLE_ADMIN'">
                            <a class="dropdown-item" uiSref="companies" uiSrefActive="active"
                                (click)="collapseNavbar()">
                                <i class="fa fa-fw fa-building-o" aria-hidden="true"></i>
                                <span jhiTranslate="global.menu.directory.companies">companies</span>
                            </a>
                        </li>
                        <li *jhiHasAnyAuthority="'ROLE_ADMIN'">
                            <a class="dropdown-item" uiSref="companyGroups" uiSrefActive="active"
                                (click)="collapseNavbar()">
                                <i class="fa fa-fw fa-university" aria-hidden="true"></i>
                                <span jhiTranslate="global.menu.directory.company-groups">company-groups</span>
                            </a>
                        </li>
                        <li *jhiHasAnyAuthority="'ROLE_ADMIN'">
                            <a class="dropdown-item" uiSref="locations" uiSrefActive="active"
                                (click)="collapseNavbar()">
                                <i class="fa fa-fw fa-industry" aria-hidden="true"></i>
                                <span jhiTranslate="global.menu.directory.locations">locations</span>
                            </a>
                        </li>
                        <li *jhiHasAnyAuthority="'ROLE_ADMIN'">
                            <a class="dropdown-item" uiSref="universes" uiSrefActive="active"
                                (click)="collapseNavbar()">
                                <i class="fa fa-fw fa-cogs" aria-hidden="true"></i>
                                <span jhiTranslate="global.menu.directory.universes">universes</span>
                            </a>
                        </li>
                        <li *jhiHasAnyAuthority="'ROLE_ADMIN'">
                            <a class="dropdown-item" uiSref="partners" uiSrefActive="active" (click)="collapseNavbar()">
                                <i class="fa fa-users" aria-hidden="true"></i>
                                <span jhiTranslate="global.menu.directory.partners">partners</span>
                            </a>
                        </li>
                    </ul>
                </li>

                <!-- Sessions for users -->
                <li *jhiHasAnyAuthority="['ROLE_TRAINER']" class="nav-item" uiSrefActive="active">
                    <a class="nav-link" uiSref="profile" (click)="collapseNavbar()">
                        <i class="fa fa-id-card-o" aria-hidden="true"></i>
                        <span class="hidden-sm" jhiTranslate="global.menu.profile">Profile</span>
                    </a>
                </li>
            </ul>
            <ul class="nav navbar-nav navbar-right">
                <ng-template *ngSwitchCase="false">
                    <li *ngFor="let language of languages">
                        <a *ngIf="language !== currentLang" class="dropdown-item" [jhiActiveMenu]="language"
                            href="javascript:void(0);" (click)="changeLanguage(language);collapseNavbar();">
                            <i class="fa fa-language" aria-hidden="true"></i> {{language | findLanguageFromKey}}</a>
                    </li>
                </ng-template>

                <!-- Account connected -->
                <li ngbDropdown class="nav-item dropdown pointer" *ngSwitchCase="true">
                    <a class="nav-link dropdown-toggle" ngbDropdownToggle href="javascript:void(0);" id="account-menu">
                        <span *ngIf="!getImageUrl()">
                            <i class="fa fa-user-circle-o" aria-hidden="true"></i>
                            <span class="hidden-sm" jhi-translate="global.menu.account.main">
                                {{ 'global.menu.account.main' | translate}}
                            </span>
                        </span>
                        <span *ngIf="getImageUrl()">
                            <img [src]="getImageUrl()" class="profile-image img-circle">
                        </span>
                    </a>

                    <ul class="dropdown-menu pull-right" ngbDropdownMenu>
                        <!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here -->
                        <li>
                            <a class="dropdown-item" (click)="logout()" id="logout">
                                <i class="fa fa-fw fa-sign-out" aria-hidden="true"></i>
                                <span jhiTranslate="global.menu.account.logout">Sign out</span>
                            </a>
                        </li>

                        <li *jhiHasAnyAuthority="['ROLE_ADMIN', 'ROLE_SALE']" role="separator" class="divider"></li>

                        <li>
                            <a *jhiHasAnyAuthority="['ROLE_ADMIN', 'ROLE_SALE']" class="dropdown-item"
                                uiSref="technical" uiSrefActive="active" (click)="collapseNavbar()">
                                <i class="fa fa-fw fa-rocket" aria-hidden="true"></i>
                                <span jhiTranslate="global.menu.admin.technical">Technical services</span>
                            </a>
                        </li>


                        <!-- Annuaire -->

                        <li role="separator" class="divider" *jhiHasAnyAuthority="'ROLE_ADMIN'"></li>
                        <li *jhiHasAnyAuthority="'ROLE_ADMIN'">
                            <a class="dropdown-item" uiSref="students" uiSrefActive="active" (click)="collapseNavbar()">
                                <i class="fa fa-fw fa-graduation-cap" aria-hidden="true"></i>
                                <span jhiTranslate="global.menu.directory.students">students</span>
                            </a>
                        </li>
                        <li *jhiHasAnyAuthority="'ROLE_ADMIN'">
                            <a class="dropdown-item" uiSref="contacts" uiSrefActive="active" (click)="collapseNavbar()">
                                <i class="fa fa-fw fa-user" aria-hidden="true"></i>
                                <span jhiTranslate="global.menu.directory.contacts">contacts</span>
                            </a>
                        </li>
                        <li *jhiHasAnyAuthority="'ROLE_ADMIN'">
                            <a class="dropdown-item" uiSref="companies" uiSrefActive="active"
                                (click)="collapseNavbar()">
                                <i class="fa fa-fw fa-building-o" aria-hidden="true"></i>
                                <span jhiTranslate="global.menu.directory.companies">companies</span>
                            </a>
                        </li>
                        <li *jhiHasAnyAuthority="'ROLE_ADMIN'">
                            <a class="dropdown-item" uiSref="companyGroups" uiSrefActive="active"
                                (click)="collapseNavbar()">
                                <i class="fa fa-fw fa-university" aria-hidden="true"></i>
                                <span jhiTranslate="global.menu.directory.company-groups">company-groups</span>
                            </a>
                        </li>
                        <li *jhiHasAnyAuthority="'ROLE_ADMIN'">
                            <a class="dropdown-item" uiSref="locations" uiSrefActive="active"
                                (click)="collapseNavbar()">
                                <i class="fa fa-fw fa-industry" aria-hidden="true"></i>
                                <span jhiTranslate="global.menu.directory.locations">locations</span>
                            </a>
                        </li>
                        <li *jhiHasAnyAuthority="'ROLE_ADMIN'">
                            <a class="dropdown-item" uiSref="universes" uiSrefActive="active"
                                (click)="collapseNavbar()">
                                <i class="fa fa-fw fa-cogs" aria-hidden="true"></i>
                                <span jhiTranslate="global.menu.directory.universes">universes</span>
                            </a>
                        </li>
                        <li *jhiHasAnyAuthority="'ROLE_ADMIN'">
                            <a class="dropdown-item" uiSref="partners" uiSrefActive="active" (click)="collapseNavbar()">
                                <i class="fa fa-users" aria-hidden="true"></i>
                                <span jhiTranslate="global.menu.directory.partners">partners</span>
                            </a>
                        </li>


                        <!-- Technical admin screens-->

                        <li role="separator" class="divider" *jhiHasAnyAuthority="'ROLE_ADMIN'"></li>

                        <li *jhiHasAnyAuthority="'ROLE_ADMIN'">
                            <a class="dropdown-item" uiSref="jhi-metrics" uiSrefActive="active"
                                (click)="collapseNavbar()">
                                <i class="fa fa-fw fa-tachometer" aria-hidden="true"></i>
                                <span jhiTranslate="global.menu.admin.metrics">Metrics</span>
                            </a>
                        </li>
                        <li *jhiHasAnyAuthority="'ROLE_ADMIN'">
                            <a class="dropdown-item" uiSref="jhi-health" uiSrefActive="active"
                                (click)="collapseNavbar()">
                                <i class="fa fa-fw fa-heart" aria-hidden="true"></i>
                                <span jhiTranslate="global.menu.admin.health">Health</span>
                            </a>
                        </li>
                        <li *jhiHasAnyAuthority="'ROLE_ADMIN'">
                            <a class="dropdown-item" uiSref="jhi-configuration" uiSrefActive="active"
                                (click)="collapseNavbar()">
                                <i class="fa fa-fw fa-list" aria-hidden="true"></i>
                                <span jhiTranslate="global.menu.admin.configuration">Configuration</span>
                            </a>
                        </li>
                        <li *jhiHasAnyAuthority="'ROLE_ADMIN'">
                            <a class="dropdown-item" uiSref="audits" uiSrefActive="active" (click)="collapseNavbar()">
                                <i class="fa fa-fw fa-bell" aria-hidden="true"></i>
                                <span jhiTranslate="global.menu.admin.audits">Audits</span>
                            </a>
                        </li>
                        <li *jhiHasAnyAuthority="'ROLE_ADMIN'">
                            <a class="dropdown-item" uiSref="logs" uiSrefActive="active" (click)="collapseNavbar()">
                                <i class="fa fa-fw fa-tasks" aria-hidden="true"></i>
                                <span jhiTranslate="global.menu.admin.logs">Logs</span>
                            </a>
                        </li>
                        <li *jhiHasAnyAuthority="'ROLE_ADMIN'">
                            <a class="dropdown-item" uiSref="docs" uiSrefActive="active" (click)="collapseNavbar()">
                                <i class="fa fa-fw fa-book" aria-hidden="true"></i>
                                <span jhiTranslate="global.menu.admin.apidocs">API</span>
                            </a>
                        </li>

                        <li role="separator" class="divider"></li>

                        <li *ngFor="let language of languages">
                            <a *ngIf="language !== currentLang" class="dropdown-item" [jhiActiveMenu]="language"
                                href="javascript:void(0);" (click)="changeLanguage(language);collapseNavbar();">{{language |
                                findLanguageFromKey}}</a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</nav>


// WEBPACK FOOTER //
// ./src/app/layouts/navbar/navbar.component.html